export default __webpack_public_path__ + "static/media/doclist.f453c279.gif";